import { render, staticRenderFns } from "./PreviewApprovalModal.vue?vue&type=template&id=06f45d7d"
import script from "./PreviewApprovalModal.vue?vue&type=script&lang=js"
export * from "./PreviewApprovalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports